import * as fromDatatype from '../datatype-library/index';

// linking to other database table.

export interface app_login_cfg_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  app_login_guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  value: fromDatatype.JsonDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
}

export class app_login_cfg_RowClass
  implements app_login_cfg_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  app_login_guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  value: fromDatatype.JsonDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
}
